/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserRoyalGroupQueryVariables = GraphQL.Exact<{
  legacyUserId: GraphQL.Scalars['ID']['input'];
}>;


export type UserRoyalGroupQuery = { readonly __typename?: 'Query', readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string, readonly royalGroup: GraphQL.RoyalGroup | null } | null };


export const UserRoyalGroupDocument = gql`
    query UserRoyalGroup($legacyUserId: ID!) {
  user(legacyId: $legacyUserId) {
    id
    legacyId
    royalGroup
  }
}
    `;

/**
 * __useUserRoyalGroupQuery__
 *
 * To run a query within a React component, call `useUserRoyalGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRoyalGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRoyalGroupQuery({
 *   variables: {
 *      legacyUserId: // value for 'legacyUserId'
 *   },
 * });
 */
export function useUserRoyalGroupQuery(baseOptions: Apollo.QueryHookOptions<UserRoyalGroupQuery, UserRoyalGroupQueryVariables> & ({ variables: UserRoyalGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRoyalGroupQuery, UserRoyalGroupQueryVariables>(UserRoyalGroupDocument, options);
      }
export function useUserRoyalGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRoyalGroupQuery, UserRoyalGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRoyalGroupQuery, UserRoyalGroupQueryVariables>(UserRoyalGroupDocument, options);
        }
export function useUserRoyalGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserRoyalGroupQuery, UserRoyalGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserRoyalGroupQuery, UserRoyalGroupQueryVariables>(UserRoyalGroupDocument, options);
        }
export type UserRoyalGroupQueryHookResult = ReturnType<typeof useUserRoyalGroupQuery>;
export type UserRoyalGroupLazyQueryHookResult = ReturnType<typeof useUserRoyalGroupLazyQuery>;
export type UserRoyalGroupSuspenseQueryHookResult = ReturnType<typeof useUserRoyalGroupSuspenseQuery>;
export type UserRoyalGroupQueryResult = Apollo.QueryResult<UserRoyalGroupQuery, UserRoyalGroupQueryVariables>;